module.exports = __webpack_public_path__ + "static/media/empresa1.039b3055.jpg";